export class ScreenDimensions extends HTMLElement {
    constructor() {
        super();
     }

    connectedCallback() {
        this.init();
    }

    init() {
        // check if the current screen dimensions have already been registered
        const currentWidth = window.innerWidth;
        const currentHeight = window.innerHeight;
        const screenDimensions = this.dataset.screen_dimensions;
        let send = true;
        if (screenDimensions) {
            const dimensions = JSON.parse(screenDimensions);
            if (dimensions && typeof dimensions == 'object') {
                dimensions.forEach((dimension) => {
                    if (dimension.width == currentWidth && dimension.height == currentHeight) {
                        send = false;
                    }
                });
                
            }
        }
        if (send) {
            this.sendDimensions(currentWidth, currentHeight);
        }
    }

    sendDimensions(width, height) {
        // send the screen dimensions to the server
        const formData = new FormData();
        formData.append('width', width);
        formData.append('height', height);
        // send the dimensions to the server
        fetch('/api/screen-dimensions', {
            method: 'POST',
            body: formData,
            accept: 'application/json',
         }).then(response => {
                if (response.ok) {
                    console.log('Screen dimensions sent to server');
                } else {
                    console.error('Error sending screen dimensions to server');
                }
        }).catch(error => {
            console.error('Error sending screen dimensions to server', error);
        });     
    }

}

customElements.define('screen-dimensions', ScreenDimensions);